module.exports = __webpack_public_path__ + "static/media/maximize-earnings.e05b5bae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/maximize-earnings.png
// module id = 2173
// module chunks = 0